import React, { useState, useEffect } from 'react';
import useLocalStorage from '../hooks/useLocalStorage';
import GenericSection from '../components/sections/GenericSection';
import SectionHeader from '../components/sections/partials/SectionHeader';
import B2BProductList from '../components/sections/B2BProductList';
import Input from '../components/elements/Input';
import Button from '../components/elements/Button';
import { Link } from 'react-router-dom';

const Catalog = () => {
  const [quoteCart, setQuoteCart] = useLocalStorage('sees_quote_cart', []);
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch('/api/hubspot-products');
        if (!response.ok) throw new Error('Network error');
        const data = await response.json();
        if (Array.isArray(data)) {
          setProducts(data);
        } else {
          setProducts([]);
        }
      } catch (error) {
        console.error('Failed to load catalog products:', error);
        setProducts([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchProducts();
  }, []);

  const filteredProducts = products.filter(p => 
    p.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
    (p.description && p.description.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const handleAddToQuote = (product) => {
    const cartItem = { ...product, cartId: Date.now() + Math.random().toString(36).substr(2, 9), quantity: 1 };
    setQuoteCart([...quoteCart, cartItem]);
  };

  const catalogHeader = {
    title: 'Most Frequently Sourced Items',
    paragraph: 'Explore our primary catalog of commercial equipment, industrial supplies, and diagnostic items. For any custom products or equipment not listed below, our global sourcing team is happy to procure them for you.',
  };

  return (
    <>
      <GenericSection topOuterDivider pb={0}>
        <SectionHeader data={catalogHeader} className="center-content" />
      </GenericSection>

      {/* Custom Item Request Notice Banner */}
      <section className="container mb-32" style={{ maxWidth: '800px', margin: '0 auto 32px' }}>
        <div className="p-24 text-center" style={{ backgroundColor: '#141C2E', borderRadius: '8px', border: '1px solid #1E293B' }}>
          <p className="text-sm m-0 mb-16" style={{ color: '#CBD5E1', lineHeight: '1.6' }}>
            <strong style={{ color: '#A88756' }}>Looking for something not in this list?</strong> We operate extensive global sourcing networks across North America, Europe, Asia, and MEA. We are happy to search and procure any commercial product or raw material for your organization.
          </p>
          <Link to="/contact">
            <Button color="primary" size="sm">Inquire for Unlisted Items →</Button>
          </Link>
        </div>
      </section>

      {/* Real-time Product Search */}
      <section className="container mb-32" style={{ maxWidth: '600px', margin: '0 auto' }}>
        <Input 
          id="catalog-search"
          type="search"
          placeholder="Search frequently sourced catalog by name or specification..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          hasIcon="right"
        />
      </section>

      {/* Products Grid */}
      {isLoading ? (
        <div className="text-center p-32">
          <p style={{ color: '#A88756' }}>Loading Product Catalog...</p>
        </div>
      ) : (
        <B2BProductList 
          products={filteredProducts} 
          onAddToQuote={handleAddToQuote}
        />
      )}

      {/* Review Quote Basket Bottom Banner */}
      <div className="text-center mt-32 mb-48">
        <Link to="/quote">
          <Button color="primary">Review Quote Request Basket ({quoteCart.length})</Button>
        </Link>
      </div>
    </>
  );
};

export default Catalog;
